import React, { useEffect } from 'react';
import styles from './create-or-edit-position-category-modal.module.scss';
import { Col, Row } from 'antd';
import { DATE_TIME_FORMAT } from '../../../../../../utils/constants';
import { BasicDatePicker, BasicInput, BasicLabel, BasicSwitch } from '../../../../../../assets/common';
import CustomAntModal from '../../../../../../components/CustomAntModal/CustomAntModal';
import { useFormik } from 'formik';
import moment from 'moment';

const CreateOrEditPositionInsightsModal = ({
  open,
  setOpen,
  positionInsightsList,
  handleSubmitPositionInsights,
  positionInsightsDetail,
  setPositionInsightsDetail,
}) => {
  const isEdit = positionInsightsDetail?.id ? true : false;

  const formik = useFormik({
    initialValues: {
      report_to: '',
      current_incumbent: '',
      startDate: null,
      endDate: null,
      noEndDate: false,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      handleSubmitPositionInsights({ ...values }, positionInsightsDetail?.id);
      formik.handleReset();
      setOpen(false);
    },
  });

  const handleChangeNoEndDate = (checked) => {
    if (!checked) {
      formik.setValues({
        noEndDate: formik.values.endDate,
        report_to: formik.values.report_to,
        current_incumbent: formik.values.current_incumbent,
        startDate: formik.values.startDate,
        endDate: null,
      });
    }
    formik.setFieldValue('noEndDate', checked);
  };

  useEffect(() => {
    if (isEdit) {
      formik.setValues({
        report_to: positionInsightsDetail.report_to || '',
        current_incumbent: positionInsightsDetail.current_incumbent || '',
        startDate: positionInsightsDetail.start_date ? moment(positionInsightsDetail.start_date) : null,
        endDate: positionInsightsDetail.end_date ? moment(positionInsightsDetail.end_date) : null,
        noEndDate: positionInsightsDetail.end_date_toggle,
      });
    }
  }, []);

  return (
    <CustomAntModal
      open={open}
      setOpen={setOpen}
      title={isEdit ? 'Edit Position Insights' : 'New Position Insights'}
      onOk={formik.submitForm}
      onCancel={() => {
        formik.handleReset();
        setPositionInsightsDetail({});
      }}
      okText={isEdit ? 'Save' : 'Add'}
      width={1000}
      destroyOnClose
    >
      <div className={styles.body}>
        <Row gutter={16}>
          <Col span={10} className={styles.customize}>
            <BasicLabel>Report to</BasicLabel>
            <BasicInput
              name="report_to"
              value={formik.values.report_to}
              onChange={(e) => formik.setFieldValue('report_to', e.target.value)}
              placeholder="Report to"
            />
          </Col>
          <Col span={10} className={styles.customize}>
            <BasicLabel>Current Incumbent</BasicLabel>
            <BasicInput
              name="current_incumbent"
              value={formik.values.current_incumbent}
              onChange={(e) => formik.setFieldValue('current_incumbent', e.target.value)}
              placeholder="Current Incumbent"
            />
          </Col>
        </Row>
        <Row gutter={16} className="mb-6">
          <Col span={10} className={styles.customize}>
            <BasicLabel>Start Date</BasicLabel>
            <BasicDatePicker
              format={DATE_TIME_FORMAT.DATE_SLASH}
              placeholder="Start Date"
              getPopupContainer={(trigger) => trigger}
              name="startDate"
              value={formik.values.startDate}
              onChange={(value) => formik.setFieldValue('startDate', value)}
              disabledDate={(current) => (formik.values.endDate ? current > formik.values.endDate : false)}
            />
          </Col>

          {!formik.values.noEndDate && (
            <Col span={10} className={styles.customize}>
              <BasicLabel>End Date</BasicLabel>
              <BasicDatePicker
                format={DATE_TIME_FORMAT.DATE_SLASH}
                placeholder="End Date"
                getPopupContainer={(trigger) => trigger}
                name="endDate"
                value={formik.values.endDate}
                onChange={(value) => formik.setFieldValue('endDate', value)}
                disabledDate={(current) => current < formik.values.startDate}
              />
            </Col>
          )}
          <Col span={4} className={`${styles.customize} ${styles.switch_style}`}>
            <BasicSwitch name="noEndDate" checked={formik.values.noEndDate} onChange={(checked) => handleChangeNoEndDate(checked)} />
            <BasicLabel style={{ marginLeft: '8px' }}>No end date</BasicLabel>
          </Col>
        </Row>
      </div>
    </CustomAntModal>
  );
};

export default CreateOrEditPositionInsightsModal;
